import type { RouteRecordRaw } from 'vue-router'
import routerNames from './routerNames'
import routerTitle from './RouterTitle'
import breadcrumbName from './breadcrumbName'

const AdminManagerRouter: RouteRecordRaw = {
  path: '/',
  meta: {
    requiresAuth: true,
    breadcrumb: breadcrumbName.MANAGER
  },
  component: () => import('@/layouts/DefaultLayout.vue'),
  redirect: { name: routerNames.PROJECT },
  children: [
    {
      name: routerNames.PROJECT,
      path: 'projects',
      component: () => import('@/views/Manager/ProjectView.vue'),
      meta: {
        title: routerTitle.PROJECT,
        breadcrumb: breadcrumbName.MANAGER
      }
    },
    {
      name: routerNames.DETAIL_PROJECT,
      path: 'projects/:projectId',
      component: () => import('@/views/Manager/ProjectDetailView.vue'),
      meta: {
        title: routerTitle.DETAIL_PROJECT,
        breadcrumb: breadcrumbName.MANAGER
      }
    },
    {
      name: routerNames.FEEDBACK_BACK_PROJECT,
      path: 'projects/:projectId/feedback',
      component: () => import('@/views/Manager/Feedback/FeedbackProjectView.vue'),
      meta: {
        title: routerTitle.FEEDBACK_BACK_PROJECT,
        breadcrumb: breadcrumbName.MANAGER
      }
    },
    {
      name: routerNames.FEEDBACK_BACK_PROJECT_CONFIRM,
      path: 'projects/:projectId/feedback/confirm',
      component: () => import('@/views/Manager/Feedback/FeedbackProjectConfirmView.vue'),
      meta: {
        title: routerTitle.FEEDBACK_BACK_PROJECT_CONFIRM,
        breadcrumb: breadcrumbName.MANAGER
      }
    },
    {
      name: routerNames.FEEDBACK_BACK_PROJECT_INTRO,
      path: 'projects/:projectId/feedback/intro',
      component: () => import('@/views/Manager/Feedback/FeedbackProjectIntroView.vue'),
      meta: {
        title: routerTitle.FEEDBACK_BACK_PROJECT_INTRO,
        breadcrumb: breadcrumbName.MANAGER
      }
    },
    {
      name: routerNames.CRAFTING_PROJECT,
      path: 'projects/:projectId/crafting',
      component: () => import('@/views/Manager/Craft/CraftingProjectView.vue'),
      meta: {
        title: routerTitle.CRAFTING_PROJECT,
        breadcrumb: breadcrumbName.MANAGER
      }
    },
    {
      name: routerNames.CRAFTING_PROJECT_CONFIRM,
      path: 'projects/:projectId/crafting/confirm',
      component: () => import('@/views/Manager/Craft/CraftingProjectConfirmView.vue'),
      meta: {
        title: routerTitle.CRAFTING_PROJECT_CONFIRM,
        breadcrumb: breadcrumbName.MANAGER
      }
    },
    {
      name: routerNames.PLAN,
      path: 'plan',
      component: () => import('@/views/Manager/PlanView.vue'),
      meta: {
        title: routerTitle.PLAN,
        breadcrumb: breadcrumbName.MANAGER
      }
    }
  ]
}

export default AdminManagerRouter
